import React from "react";
import MarkingUtils from "../../../../../../utils/marking.utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Table, TableCell, TableRow, TableBody, Tooltip } from "@mui/material";
import TextEllipsis from "../../../../../text/TextEllipsis";
import PaperBase from "../../../../../Paper/PaperBase";

const RowMin = ({ f, mf, mt, level, gsDefinition, size, nextLevel }) => {
  return (
    <div className="flex gap-1 items-center justify-between">
      <TextEllipsis className="text-xs max-w-100px">
        {f.isLevel
          ? `${level?.name || f.levelId}`
          : `Working towards ${nextLevel?.name || nextLevel?._id}`}
      </TextEllipsis>
      <div className="flex gap-1 items-center justify-between">
        <Tooltip title={gsDefinition} arrow>
          <span
            className="rounded-full cursor-pointer hover-outline-muted"
            style={{
              width: size,
              height: size,
              backgroundColor: mf.primaryColor,
            }}
          />
        </Tooltip>

        <FontAwesomeIcon
          icon="arrow-right"
          className="text-muted-foreground opacity-50"
        />
        <Tooltip title={gsDefinition} arrow>
          <div
            className="rounded-full cursor-pointer hover-outline-muted"
            style={{
              width: size,
              height: size,
              backgroundColor: mt.primaryColor,
            }}
          />
        </Tooltip>
      </div>
    </div>
  );
};

const RowMax = ({ f, mf, mt, level, gsDefinition, nextLevel }) => {
  return (
    <div className="flex gap-1 items-center justify-between">
      <PaperBase
        className="font-bold min-w-100px max-w-100px sticky left-0 z-10 bg-transparent text-muted-foreground opacity-50"
        outline={`1px solid transparent`}
        children={
          f.isLevel
            ? `${level?.name || f.levelId}`
            : `Working towards ${nextLevel?.name || nextLevel?._id}`
        }
      />
      <div className="flex gap-1 items-center justify-between">
        <PaperBase
          color={mf.secondaryColor}
          backgroundColor={mf.primaryColor}
          className="min-w-200px max-w-200px"
          children={gsDefinition}
        />
        <FontAwesomeIcon
          icon="arrow-right"
          className="text-muted-foreground opacity-50 text-2xl"
        />
        <PaperBase
          color={mt.secondaryColor}
          backgroundColor={mt.primaryColor}
          className="min-w-200px max-w-200px"
          children={gsDefinition}
        />
      </div>
    </div>
  );
};

const ElementsFromTo = ({
  id,
  currentCurriculum,
  granularSteps,
  from,
  to,
  type = "min",
}) => {
  const minMarking =
    currentCurriculum?.marking?.find((item) => item.minValue) || {};
  const sortFrom = MarkingUtils.sortGranularSteps(
    currentCurriculum.levels,
    from
  );
  const sortTo = MarkingUtils.sortGranularSteps(currentCurriculum.levels, to);

  const findMarking = (id) => {
    return (
      currentCurriculum.marking.find((item) => item._id === id) || minMarking
    );
  };
  const levels = currentCurriculum.levels.sort((a, b) => a.position - b.position);

  const size = 16;
  return (
    <Table className="mb-4">
      <TableBody>
        {sortFrom
          .filter(
            (f) => granularSteps?.find((item) => item.id === f.id)?.definition
          )
          .map((f, i) => {
            const level = levels.find(
              (item) => item._id === f.levelId
            );
            const findIndexLevel = levels.findIndex(
              (item) => item._id === f.levelId
            );
            const nextLevel = levels[findIndexLevel + 1];
            const t = sortTo[i];
            const mf = findMarking(f?.completed);
            const mt = findMarking(t?.completed);
            const gsDefinition = granularSteps?.find(
              (item) => item.id === f.id
            )?.definition;

            return (
              <TableRow key={`log-${id}-${f.level}-gs-${f.id}`}>
                <TableCell>
                  {type === "min" ? (
                    <RowMin
                      f={f}
                      mf={mf}
                      t={t}
                      mt={mt}
                      level={level}
                      nextLevel={nextLevel}
                      gsDefinition={gsDefinition}
                      size={size}
                    />
                  ) : (
                    <RowMax
                      f={f}
                      mf={mf}
                      t={t}
                      mt={mt}
                      level={level}
                      nextLevel={nextLevel}
                      gsDefinition={gsDefinition}
                      size={size}
                    />
                  )}
                </TableCell>
              </TableRow>
            );
          })}
      </TableBody>
    </Table>
  );
};

export default ElementsFromTo;
